module.exports = __webpack_public_path__ + "static/img/timg.0b40d0c0.jpg";